import { render } from "./OrderOverview.vue?vue&type=template&id=44d4326d&scoped=true"
import script from "./OrderOverview.js?vue&type=script&lang=js"
export * from "./OrderOverview.js?vue&type=script&lang=js"

import "./OrderOverview.scss?vue&type=style&index=0&id=44d4326d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d4326d"]])

export default __exports__